import * as React from "react";
import axios from "axios";
import { RiArrowLeftLine } from "react-icons/ri";
import ReCAPTCHA from "react-google-recaptcha";

import Textfield from "../../Components/Textfield";
import Modal from "../../Components/Modal";
import Button from "../../Components/Button";
import StandardLink from "../../Components/StandardLink";
import Copyright from "../../Components/Copyright";

import { useLoader } from "../../Context/LoaderContext";
import { useToast } from "../../Context/ToastContext";

import Logo from "../../Images/logo.png";
import imgLogin from "../../Images/bg.jpg";
import defaultImgLogin from "../../Images/bg-login.png";

import "./ForgetPassword.scss";

const ForgetPassword = () => {
  const [email, setEmail] = React.useState("");
  const [welcomeBanner, setWelcomeBanner] = React.useState(imgLogin);
  const [welcomeBannerLink, setWelcomeBannerLink] = React.useState(null);
  const [welcomeBannerTitle, setWelcomeBannerTitle] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [captchaDone, setIsCaptachDone] = React.useState(false);
  const [tokenRecaptcha, setTokenRecaptcha] = React.useState(null);

  const captchaRef = React.useRef(null);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  
    React.useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    const captchaSize = windowWidth > 480 ? "normal" : "compact";

  const { setIsLoading } = useLoader();
  const { addToast } = useToast();

  React.useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/get-welcome-banner/forget_password`
      )
      .then((response) => {
        setIsLoading(false);
        if (
          typeof response.data.data.banner.image != "undefined" &&
          response.data.data.banner.image != null
        ) {
          setWelcomeBanner(response.data.data.banner.image);
          setWelcomeBannerLink(response.data.data.banner.link);
          setWelcomeBannerTitle(response.data.data.banner.title);
        } else {
          setWelcomeBanner(defaultImgLogin);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setWelcomeBanner(defaultImgLogin);
      });
  }, [setIsLoading]);

  const handleChangeField = (e) => {
    setEmail(e.target.value);
    setErrorMessage("");
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/password/forgot`, {
        email,
        grt: tokenRecaptcha
      })
      .then((response) => {
        setIsLoading(false);
        if (response.data.status) {
          const message = typeof response.data.message === 'object' ? JSON.stringify(response.data.message) : response.data.message;
          setMessage(message);
        } else {
          const errorMessage = typeof response.data.message === 'object' ? JSON.stringify(response.data.message) : response.data.message;
          setErrorMessage(errorMessage);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        captchaRef.current.reset();
        setIsCaptachDone(false);
        if (!error.response.data.status) {
          // setErrorMessage(error.response.data.message);
          addToast({
            variant: "danger",
            message: errorMessage || error.response.data.message,
          });
        } else {
          const errorMessage = typeof error.response.data.data === 'object' ? JSON.stringify(error.response.data.data) : error.response.data.data;
          addToast({
            variant: "danger",
            message: errorMessage || error.response.data.message,
          });
        }
    });
  };
  
  const onChangeCaptcha = (value) => {
    setIsCaptachDone(true);
    setTokenRecaptcha(value)
  };


  return (
    <div className="forget-password">
      <div className="wrap-password-page">
        <div className="content-form">
          <div className="logo">
            <img src={Logo} alt="" />
          </div>
          <h1 className="title">Mot de passe oublié</h1>
          <p className="sub-title">
            Merci de renseigner votre adresse email pour recevoir le code
          </p>

          <form className="login-form" onSubmit={handleSubmit}>
            <Textfield
              label="Adresse e-mail"
              name="email"
              type="text"
              placeholder="Veuillez insérer votre Adresse e-mail"
              size="large"
              autoComplete="on"
              value={email}
              onChange={handleChangeField}
              hasError={errorMessage}
            />
            {errorMessage && (
              <div className="error text-danger pb-4">{errorMessage}</div>
            )}
            <div className="captcha-box">
              <ReCAPTCHA
                key={captchaSize}
                sitekey={process.env.REACT_APP_SITE_KEY}
                ref={captchaRef}
                onChange={onChangeCaptcha}
                size={captchaSize}
              />
            </div>
            <div className="wrap_actions_form mb-3">
              <StandardLink variant="dark" size="lg" to="/login">
                Annuler
              </StandardLink>
              <Button
                type="submit"
                size="lg"
                disabled={captchaDone ? false : true}
              >
                Envoyer
              </Button>
            </div>
          </form>
          <Modal
            title="Réinitialisation du mot de passe"
            isDismissible={false}
            isOpen={!!message}
          >
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <StandardLink to="/" className="mt-16">
              <RiArrowLeftLine />
              Retour
            </StandardLink>
          </Modal>
        </div>
        {welcomeBannerLink === null ? (
          <div className="img-login">
            <img
              src={welcomeBanner}
              alt={welcomeBannerTitle}
              title={welcomeBannerTitle}
            />
          </div>
        ) : (
          <div className="img-login">
            <a href={welcomeBannerLink} target="_blank" rel="noreferrer">
              <img
                src={welcomeBanner}
                alt={welcomeBannerTitle}
                title={welcomeBannerTitle}
              />
            </a>
          </div>
        )}
      </div>
      <Copyright />
    </div>
  );
};

export default ForgetPassword;
